import Vue from 'vue'
import SvgIconV2 from '@/components/SvgIconV2/SvgIconV2.vue' // svg component

// register globally
Vue.component('SvgIconV2', SvgIconV2)

const req = require.context('@/icons/svgV2', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
